import React from "react";

// import FwProfileScreen from "../../pages/FwProfileScreen";
// import FwProfileScreen from "./FwProfileScreen";
import FwProfileScreen from "../../pages/FwProfileScreen";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"

const ProfilePage = ({
  name,
  email,
  mobile,
  avatarUrl,
  loading,

  onEdit,
  onMenuClick,
  onTabChange,
  onLogout,
}) => {
  return (
    
    <FwProfileScreen
      name={name}
      email={email}
      mobile={mobile}
      avatarUrl={avatarUrl}
      loading={loading}
      activeTab="profile"
      onEdit={onEdit}
      onMenuClick={onMenuClick}
      onTabChange={onTabChange}
      onLogout={onLogout}
    />
  );
};

export default ProfilePage;